export const SOCIAL_MEDIA_ENDPOINT = '/v1/cpp/social-media';

export const SOCIAL_HANDLE_MAX_LENGTH = 50;

export const SOCIAL_PLATFORMS = [
    { key: 'instagram', label: 'Instagram', icon: '/img/icons/v4/insta.svg' },
    { key: 'tiktok', label: 'TikTok', icon: '/img/icons/v4/tiktok.svg' },
    { key: 'facebook', label: 'Facebook', icon: '/img/icons/v4/facebook.svg' },
    { key: 'x', label: 'X', icon: '/img/icons/v4/x.svg' },
    { key: 'youtube', label: 'YouTube', icon: '/img/icons/v4/youtube.svg' },
];
